module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjQxNSIgdmlld0JveD0iMCAwIDIwMDAgNDE1IiB3aWR0aD0iMjAwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNTAlIiB4Mj0iNTAlIiB5MT0iNTAlIiB5Mj0iOTkuMTU3JSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmZmIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZjRlZmZlIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJtLTIgNjVoMjAwMnY0MTVoLTIwMDJ6IiBmaWxsPSJ1cmwoI2EpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTY1KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_post-hero.svg
// module id = Jkg/
// module chunks = 0